<p-dialog
  header="Resume unsaved editing sessions?"
  [visible]="(items$ | async)!.length > 0"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [style]="{ width: '640px', maxWidth: '92vw' }"
  appendTo="body"
  [baseZIndex]="4000">
  <p class="text-sm text-surface-600 mb-4">
    These notes were being edited in a browser tab or window that closed before the editing session ended. Choose
    what to do with each one.
  </p>

  <div class="flex flex-col gap-3">
    <div
      *ngFor="let item of items$ | async"
      class="rounded-lg border border-surface-200 dark:border-surface-700 p-3">
      <div class="font-semibold">{{ item.noteTitle }}</div>
      <div class="text-xs text-surface-500 mt-1">
        Opened {{ formatDate(item.openedAt) }} &middot; {{ item.currentStateLabel }}
      </div>
      <div class="text-xs text-amber-600 mt-1">
        Restoring the opening version discards the autosaved edits made during that session.
      </div>
      <div class="flex flex-wrap gap-2 mt-3">
        <p-button
          label="Keep current note and remove snapshot"
          size="small"
          severity="secondary"
          (onClick)="keepCurrent(item)"></p-button>
        <p-button
          label="Restore opening version"
          size="small"
          severity="danger"
          (onClick)="restore(item)"></p-button>
        <p-button
          label="Review later"
          size="small"
          severity="secondary"
          [text]="true"
          (onClick)="reviewLater(item)"></p-button>
      </div>
    </div>
  </div>
</p-dialog>
